import React, { Suspense } from 'react'
import loadComponent from 'src/utils/loadMFE'

const PrivacyAgreementComponent = React.lazy(() => loadComponent('orga', 'PrivacyAgreement'))

export function PrivacyAgreement() {
    return (
        <Suspense fallback={null}>
            <PrivacyAgreementComponent />
        </Suspense>
    )
}
